<div class="mb-6">
  <h2 class="text-xl font-bold leading-8 text-blue-900">Contact Information</h2>
  <p class="text-gray-750 text-base">Tell us how we can reach you</p>
</div>

<csl-personal-details
  class="self-stretch"
  (personalDetailsChange)="onPersonalDetailsChange($event)"
  (firstNameError)="trackControlError('firstName', $event)"
  (lastNameError)="trackControlError('lastName', $event)"
  (emailError)="trackControlError('email', $event)"
  (phoneError)="trackControlError('phone', $event)"
  (firstNameHolderError)="trackControlError('firstNameHolder', $event)"
  (lastNameHolderError)="trackControlError('lastNameHolder', $event)"
  (phoneHolderError)="trackControlError('phoneHolder', $event)"
/>

<div class="mt-10">
  <h2 class="text-xl font-bold leading-8 text-blue-900">Billing Address</h2>
  <p class="text-gray-750 text-base">Enter your billing address information</p>
</div>

<csl-billing-address
  class="mt-6 block"
  [address]="address"
  (addressChange)="addressChanged($event)"
  (streetError)="trackControlError('street', $event)"
  (cityError)="trackControlError('city', $event)"
  (zipError)="trackControlError('zip_code', $event)"
  (stateError)="trackControlError('state', $event)"
/>
